export const PINYIN_INITIALS = [
  { symbol: 'b', example: '爸爸', emoji: '👨', speakChar: '巴' },
  { symbol: 'p', example: '泡泡', emoji: '🫧', speakChar: '怕' },
  { symbol: 'm', example: '妈妈', emoji: '👩', speakChar: '妈' },
  { symbol: 'f', example: '飞机', emoji: '✈️', speakChar: '发' },
  { symbol: 'd', example: '大象', emoji: '🐘', speakChar: '大' },
  { symbol: 't', example: '他', emoji: '👦', speakChar: '他' },
  { symbol: 'n', example: '你好', emoji: '👋', speakChar: '那' },
  { symbol: 'l', example: '了', emoji: '✅', speakChar: '拉' },
  { symbol: 'g', example: '歌', emoji: '🎵', speakChar: '歌' },
  { symbol: 'k', example: '可爱', emoji: '😊', speakChar: '可' },
  { symbol: 'h', example: '好', emoji: '👍', speakChar: '哈' },
  { symbol: 'j', example: '家', emoji: '🏠', speakChar: '家' },
  { symbol: 'q', example: '气球', emoji: '🎈', speakChar: '去' },
  { symbol: 'x', example: '小', emoji: '🤏', speakChar: '下' },
  { symbol: 'zh', example: '知道', emoji: '🧠', speakChar: '知' },
  { symbol: 'ch', example: '吃饭', emoji: '🍚', speakChar: '吃' },
  { symbol: 'sh', example: '是', emoji: '✔️', speakChar: '是' },
  { symbol: 'r', example: '热', emoji: '🔥', speakChar: '热' },
  { symbol: 'z', example: '在', emoji: '📍', speakChar: '在' },
  { symbol: 'c', example: '次', emoji: '🔢', speakChar: '次' },
  { symbol: 's', example: '四', emoji: '4️⃣', speakChar: '四' }
];

export const PINYIN_FINALS = [
  { symbol: 'a', example: '啊', emoji: '😮', speakChar: '啊' },
  { symbol: 'o', example: '哦', emoji: '😯', speakChar: '哦' },
  { symbol: 'e', example: '鹅', emoji: '🦢', speakChar: '鹅' },
  { symbol: 'i', example: '一', emoji: '1️⃣', speakChar: '一' },
  { symbol: 'u', example: '五', emoji: '5️⃣', speakChar: '五' },
  { symbol: 'ü', example: '鱼', emoji: '🐟', speakChar: '鱼' },
  { symbol: 'ai', example: '爱', emoji: '❤️', speakChar: '爱' },
  { symbol: 'ei', example: '杯子', emoji: '🥤', speakChar: '欸' },
  { symbol: 'ui', example: '水', emoji: '💧', speakChar: '水' },
  { symbol: 'ao', example: '猫', emoji: '🐱', speakChar: '猫' },
  { symbol: 'ou', example: '狗', emoji: '🐶', speakChar: '狗' },
  { symbol: 'iu', example: '牛', emoji: '🐮', speakChar: '牛' },
  { symbol: 'ie', example: '鞋', emoji: '👟', speakChar: '鞋' },
  { symbol: 'üe', example: '月亮', emoji: '🌙', speakChar: '月' },
  { symbol: 'er', example: '儿童', emoji: '👶', speakChar: '耳' },
  { symbol: 'an', example: '山', emoji: '⛰️', speakChar: '山' },
  { symbol: 'en', example: '门', emoji: '🚪', speakChar: '门' },
  { symbol: 'in', example: '心', emoji: '💖', speakChar: '心' },
  { symbol: 'un', example: '云', emoji: '☁️', speakChar: '云' },
  { symbol: 'ün', example: '军', emoji: '🪖', speakChar: '军' },
  { symbol: 'ang', example: '糖', emoji: '🍬', speakChar: '糖' },
  { symbol: 'eng', example: '灯', emoji: '💡', speakChar: '灯' },
  { symbol: 'ing', example: '星星', emoji: '⭐', speakChar: '星' },
  { symbol: 'ong', example: '龙', emoji: '🐉', speakChar: '龙' },
  { symbol: 'ia', example: '家', emoji: '🏡', speakChar: '家' },
  { symbol: 'iao', example: '小鸟', emoji: '🐦', speakChar: '鸟' },
  { symbol: 'ian', example: '天', emoji: '🌤️', speakChar: '天' },
  { symbol: 'iang', example: '象', emoji: '🐘', speakChar: '象' },
  { symbol: 'iong', example: '熊', emoji: '🐻', speakChar: '熊' },
  { symbol: 'ua', example: '花', emoji: '🌸', speakChar: '花' },
  { symbol: 'uo', example: '果', emoji: '🍎', speakChar: '果' },
  { symbol: 'uai', example: '快', emoji: '⚡', speakChar: '快' },
  { symbol: 'uan', example: '碗', emoji: '🥣', speakChar: '碗' },
  { symbol: 'uang', example: '黄', emoji: '💛', speakChar: '黄' },
  { symbol: 'ueng', example: '翁', emoji: '👴', speakChar: '翁' },
  { symbol: 'üan', example: '圆', emoji: '⭕', speakChar: '圆' }
];

export const HIRAGANA_ROWS = [
  {
    row: 'あ行',
    kanas: [
      { char: 'あ', romaji: 'a' },
      { char: 'い', romaji: 'i' },
      { char: 'う', romaji: 'u' },
      { char: 'え', romaji: 'e' },
      { char: 'お', romaji: 'o' }
    ]
  },
  {
    row: 'か行',
    kanas: [
      { char: 'か', romaji: 'ka' },
      { char: 'き', romaji: 'ki' },
      { char: 'く', romaji: 'ku' },
      { char: 'け', romaji: 'ke' },
      { char: 'こ', romaji: 'ko' }
    ]
  },
  {
    row: 'さ行',
    kanas: [
      { char: 'さ', romaji: 'sa' },
      { char: 'し', romaji: 'shi' },
      { char: 'す', romaji: 'su' },
      { char: 'せ', romaji: 'se' },
      { char: 'そ', romaji: 'so' }
    ]
  },
  {
    row: 'た行',
    kanas: [
      { char: 'た', romaji: 'ta' },
      { char: 'ち', romaji: 'chi' },
      { char: 'つ', romaji: 'tsu' },
      { char: 'て', romaji: 'te' },
      { char: 'と', romaji: 'to' }
    ]
  },
  {
    row: 'な行',
    kanas: [
      { char: 'な', romaji: 'na' },
      { char: 'に', romaji: 'ni' },
      { char: 'ぬ', romaji: 'nu' },
      { char: 'ね', romaji: 'ne' },
      { char: 'の', romaji: 'no' }
    ]
  },
  {
    row: 'は行',
    kanas: [
      { char: 'は', romaji: 'ha' },
      { char: 'ひ', romaji: 'hi' },
      { char: 'ふ', romaji: 'fu' },
      { char: 'へ', romaji: 'he' },
      { char: 'ほ', romaji: 'ho' }
    ]
  },
  {
    row: 'ま行',
    kanas: [
      { char: 'ま', romaji: 'ma' },
      { char: 'み', romaji: 'mi' },
      { char: 'む', romaji: 'mu' },
      { char: 'め', romaji: 'me' },
      { char: 'も', romaji: 'mo' }
    ]
  },
  {
    row: 'や行',
    kanas: [
      { char: 'や', romaji: 'ya' },
      { char: 'ゆ', romaji: 'yu' },
      { char: 'よ', romaji: 'yo' }
    ]
  },
  {
    row: 'ら行',
    kanas: [
      { char: 'ら', romaji: 'ra' },
      { char: 'り', romaji: 'ri' },
      { char: 'る', romaji: 'ru' },
      { char: 'れ', romaji: 're' },
      { char: 'ろ', romaji: 'ro' }
    ]
  },
  {
    row: 'わ行',
    kanas: [
      { char: 'わ', romaji: 'wa' },
      { char: 'を', romaji: 'wo' },
      { char: 'ん', romaji: 'n' }
    ]
  }
];

export const KATAKANA_ROWS = [
  {
    row: 'ア行',
    kanas: [
      { char: 'ア', romaji: 'a' },
      { char: 'イ', romaji: 'i' },
      { char: 'ウ', romaji: 'u' },
      { char: 'エ', romaji: 'e' },
      { char: 'オ', romaji: 'o' }
    ]
  },
  {
    row: 'カ行',
    kanas: [
      { char: 'カ', romaji: 'ka' },
      { char: 'キ', romaji: 'ki' },
      { char: 'ク', romaji: 'ku' },
      { char: 'ケ', romaji: 'ke' },
      { char: 'コ', romaji: 'ko' }
    ]
  },
  {
    row: 'サ行',
    kanas: [
      { char: 'サ', romaji: 'sa' },
      { char: 'シ', romaji: 'shi' },
      { char: 'ス', romaji: 'su' },
      { char: 'セ', romaji: 'se' },
      { char: 'ソ', romaji: 'so' }
    ]
  },
  {
    row: 'タ行',
    kanas: [
      { char: 'タ', romaji: 'ta' },
      { char: 'チ', romaji: 'chi' },
      { char: 'ツ', romaji: 'tsu' },
      { char: 'テ', romaji: 'te' },
      { char: 'ト', romaji: 'to' }
    ]
  },
  {
    row: 'ナ行',
    kanas: [
      { char: 'ナ', romaji: 'na' },
      { char: 'ニ', romaji: 'ni' },
      { char: 'ヌ', romaji: 'nu' },
      { char: 'ネ', romaji: 'ne' },
      { char: 'ノ', romaji: 'no' }
    ]
  },
  {
    row: 'ハ行',
    kanas: [
      { char: 'ハ', romaji: 'ha' },
      { char: 'ヒ', romaji: 'hi' },
      { char: 'フ', romaji: 'fu' },
      { char: 'ヘ', romaji: 'he' },
      { char: 'ホ', romaji: 'ho' }
    ]
  },
  {
    row: 'マ行',
    kanas: [
      { char: 'マ', romaji: 'ma' },
      { char: 'ミ', romaji: 'mi' },
      { char: 'ム', romaji: 'mu' },
      { char: 'メ', romaji: 'me' },
      { char: 'モ', romaji: 'mo' }
    ]
  },
  {
    row: 'ヤ行',
    kanas: [
      { char: 'ヤ', romaji: 'ya' },
      { char: 'ユ', romaji: 'yu' },
      { char: 'ヨ', romaji: 'yo' }
    ]
  },
  {
    row: 'ラ行',
    kanas: [
      { char: 'ラ', romaji: 'ra' },
      { char: 'リ', romaji: 'ri' },
      { char: 'ル', romaji: 'ru' },
      { char: 'レ', romaji: 're' },
      { char: 'ロ', romaji: 'ro' }
    ]
  },
  {
    row: 'ワ行',
    kanas: [
      { char: 'ワ', romaji: 'wa' },
      { char: 'ヲ', romaji: 'wo' },
      { char: 'ン', romaji: 'n' }
    ]
  }
];

export const ENGLISH_LETTERS = [
  { upper: 'A', lower: 'a', example: 'Apple', emoji: '🍎' },
  { upper: 'B', lower: 'b', example: 'Ball', emoji: '⚽' },
  { upper: 'C', lower: 'c', example: 'Cat', emoji: '🐱' },
  { upper: 'D', lower: 'd', example: 'Dog', emoji: '🐶' },
  { upper: 'E', lower: 'e', example: 'Elephant', emoji: '🐘' },
  { upper: 'F', lower: 'f', example: 'Fish', emoji: '🐟' },
  { upper: 'G', lower: 'g', example: 'Giraffe', emoji: '🦒' },
  { upper: 'H', lower: 'h', example: 'House', emoji: '🏠' },
  { upper: 'I', lower: 'i', example: 'Ice cream', emoji: '🍦' },
  { upper: 'J', lower: 'j', example: 'Juice', emoji: '🧃' },
  { upper: 'K', lower: 'k', example: 'Kite', emoji: '🪁' },
  { upper: 'L', lower: 'l', example: 'Lion', emoji: '🦁' },
  { upper: 'M', lower: 'm', example: 'Monkey', emoji: '🐵' },
  { upper: 'N', lower: 'n', example: 'Nose', emoji: '👃' },
  { upper: 'O', lower: 'o', example: 'Orange', emoji: '🍊' },
  { upper: 'P', lower: 'p', example: 'Panda', emoji: '🐼' },
  { upper: 'Q', lower: 'q', example: 'Queen', emoji: '👸' },
  { upper: 'R', lower: 'r', example: 'Rabbit', emoji: '🐰' },
  { upper: 'S', lower: 's', example: 'Sun', emoji: '☀️' },
  { upper: 'T', lower: 't', example: 'Tiger', emoji: '🐯' },
  { upper: 'U', lower: 'u', example: 'Umbrella', emoji: '☂️' },
  { upper: 'V', lower: 'v', example: 'Violin', emoji: '🎻' },
  { upper: 'W', lower: 'w', example: 'Water', emoji: '💧' },
  { upper: 'X', lower: 'x', example: 'Xylophone', emoji: '🎹' },
  { upper: 'Y', lower: 'y', example: 'Yellow', emoji: '💛' },
  { upper: 'Z', lower: 'z', example: 'Zebra', emoji: '🦓' }
];